
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { handleScrollReset } from '@/utils/navigationUtils';

const CTASection: React.FC = () => {
  return (
    <section className="py-16 bg-primary-blue text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold mb-6">Ready to Grow Your Business?</h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto opacity-90">
          Start your 7-day free trial today. No credit card required.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link to="/business-signup" onClick={handleScrollReset}>
            <Button size="lg" variant="secondary" className="px-8 bg-white text-primary-blue hover:bg-gray-100 w-full sm:w-auto">
              Get Started <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
          <Link to="/pricing" onClick={handleScrollReset}>
            <Button size="lg" variant="outline" className="px-8 border-white bg-lime-400 hover:bg-lime-300 text-zinc-950 w-full sm:w-auto">
              View Pricing
            </Button>
          </Link>
        </div>
        <p className="mt-6 text-sm opacity-80">
          Join thousands of businesses already growing with our referral platform.
        </p>
      </div>
    </section>
  );
};

export default CTASection;
